module.exports = "pegasus/assets/circleline-google.png";